import { useManualQuery } from 'graphql-hooks';

export const QUERY = `mutation addAmazonGtinsToMlItem($asin: String!, $mlItemId: String!) {
    addAmazonGtinsToMlItem(asin: $asin, mlItemId: $mlItemId)
}`;

export function useAddAmazonGtinsToMlItem() {
  const [addAmazonGtinsToMlItem] = useManualQuery(QUERY);
  return addAmazonGtinsToMlItem;
}